export default __webpack_public_path__ + "static/media/water_heater.svg";